import React, { useEffect, useRef } from 'react';
import * as componentStyle from './caseStudyClientsAndPartners.module.scss';
import { Heading } from '../../../interface/header.interface';
import CaseStudyTestimonialCard, { CaseStudyTestimonialCardProps } from './Component/CaseStudyTestimonialCard';
import { GatsbyImageInterface } from '../../../interface/image.interface';
import { useIntersection } from '@mantine/hooks';
import { ReviewTitle } from '../../../enum/ReviewTitle';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import HeadingComponent from '../../HeadingComponent/HeadingComponent';
import ButtonComponent from '../../Home/ButtonComponent/ButtonComponent';
import { Rating } from '@mantine/core';
import { getImage } from 'gatsby-plugin-image';
import { Autoplay } from 'swiper/modules';



interface ImageInterface {
  image: GatsbyImageInterface | null;
  altText: string | null;
}
interface ReviewItemsInterface {
  ratingValue: string | null;
  link: string | null;
  title: string | null;
  elementImage: ImageInterface | null;
}
interface ReviewsInterface {
  reviewItems: ReviewItemsInterface[] | null;
}
interface RatingDataInterface  {
  reviews: ReviewsInterface | null;
}
interface RatingInterface {
  ratingData: RatingDataInterface | null;
}
interface ButtonInterface {
  buttonContext: string | null;
  slug: string | null;
}
export interface CaseStudyClientsData {
  heading: Heading[] | null;
  button: ButtonInterface | null;
}

export default function CaseStudyClientsAndPartners({ 
  clientsData,
  testimonialsData 
}: {
  clientsData: CaseStudyClientsData | null; 
  testimonialsData: CaseStudyTestimonialCardProps[] | null;
}) {

  const data: RatingInterface | null = useStaticQuery(graphql`
    query Rating {
      ratingData: wpPage(id: {eq: "cG9zdDoyMjkzMA=="}) {
        id
        title
        reviews {
          reviewItems {
            ratingValue
            link
            title
            elementImage {
              altText
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  
    const [apiReviewData] = data?.ratingData?.reviews?.reviewItems?.filter(item => item.title === ReviewTitle.DESIGNRUSH) as ReviewItemsInterface[];
  
    const swiperRef = useRef<SwiperClass | null>(null);
    const { ref, entry } = useIntersection({
      root: swiperRef.current?.el,
      threshold: 1,
    });
  
    useEffect(() => {
      const swiper = swiperRef.current;
      if (!swiper) return;
  
      entry?.isIntersecting ? swiper.autoplay?.start() : swiper.autoplay?.stop();
    }, [entry?.isIntersecting]);
  
  

  return (
    <>
      {(clientsData?.heading && !!testimonialsData?.length) && (
        <section className={componentStyle.caseStudyClientsAndPartners}>
          {clientsData?.heading && (
            <div className={componentStyle.caseStudyClientsAndPartners__container}>
              <div className={componentStyle.caseStudyClientsAndPartners__card}>
                {clientsData?.button && (
                  <HeadingComponent data={clientsData.heading} />
                )}
                {clientsData?.button?.buttonContext && 
                  <ButtonComponent 
                    buttonText={clientsData?.button?.buttonContext?.toUpperCase()} 
                    type={"text"} 
                    buttonStyle={undefined} 
                    onClick={() => navigate(clientsData?.button?.slug || '#')} 
                    disabled={undefined} 
                    loading={undefined} 
                    className={undefined} 
                  />
                }
              </div>
            </div>
          )}

          {!!testimonialsData?.length && (
            <div className={componentStyle.caseStudyClientsAndPartners__swiperSection}>
              <a href={apiReviewData?.link || '#'} target="_blank" rel="nofollow" className={componentStyle.caseStudyClientsAndPartners__swiperStaticSection}>
                <div className={componentStyle.caseStudyClientsAndPartners__ratingsInfo}>
                  <h2 className={componentStyle.caseStudyClientsAndPartners__rating}>{apiReviewData?.ratingValue || 'N/A'}</h2>

                  {apiReviewData?.ratingValue &&
                    <div className={componentStyle.caseStudyClientsAndPartners__ratingsStarList}>
                      <Rating value={Number(apiReviewData.ratingValue)} fractions={10} size={'lg'} readOnly />
                    </div>
                  }

                  {apiReviewData?.ratingValue &&
                    <div className={componentStyle.caseStudyClientsAndPartners__totalRatingsInfo}>{`Customer reviews (${apiReviewData?.ratingValue} of 5)`}</div>
                  }
                </div>
                {apiReviewData.elementImage?.image &&
                  <div className={componentStyle.caseStudyClientsAndPartners__Logo}>
                    <img src={getImage(apiReviewData.elementImage.image.localFile)?.images.fallback?.src} alt={apiReviewData.elementImage.altText || 'N/A'} />
                  </div>
                }
              </a>
              <div className={componentStyle.caseStudyClientsAndPartners__swiperOuterCard} ref={ref}>
                <Swiper
                  ref={swiperRef as any}
                  speed={600}
                  grabCursor={true}
                  modules={[Autoplay]}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    600: {
                      slidesPerView: 1.3,
                    },
                    1280: {
                      slidesPerView: 2.5,
                    },
                  }}
                  className={componentStyle.caseStudyClientsAndPartners__swiper}
                >
                  {testimonialsData?.map((data, index) => (
                    <SwiperSlide key={`slideItem${index}`} className={ componentStyle.caseStudyClientsAndPartners__swiperSlide}>
                      <CaseStudyTestimonialCard data={data} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          )}

        </section>
      )}
    </>
  )
}
